import _ from 'lodash';
export const getValue = (d, valuePath) => {
  const value = _.get(d, valuePath, 'null');
  return (value === 'null') ? null : Number(value);
};

export const getDate = (d) => {
  return d ? d.timestamp : null;
};
